module.exports = __webpack_public_path__ + "static/media/head.cc4890b2.png";